import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="w-full border-y-4 border-gold bg-plum" data-id="element-52" data-mp="1zyh2w7skw2x2">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-53" data-mp="1uy2xkxid372q">
        <h2 className="font-display text-white text-3xl sm:text-5xl" data-id="element-54" data-mp="1v05w65xky8j2">
          Keep your Sundays.{' '}
          <span className="text-gold" data-id="element-55" data-mp="1q1m6bufv8clf">Open the theme and run it.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/75" data-id="element-56" data-mp="1l29mzjo7dnnl">
          Start the stack, describe, ask, tell, think it through and take it
          outside the room. Thirty-six weeks — stacked, leveled and ready.
        </p>

        <div className="mt-7" data-id="element-57" data-mp="1790hvv7afoav">
          <Countdown size="sm" tone="dark" data-id="element-58" data-mp="179tisfjkfjl3" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-3xl border border-gold bg-gold/10 px-5 py-4 text-left" data-id="element-59" data-mp="129nrx1l4e142">
          <div data-id="element-60" data-mp="xbcl6zq4g6q2">
            <span className="block text-[10px] font-semibold uppercase tracking-widest text-gold" data-id="element-61" data-mp="xcnm8rs6n0dh">
              Complete package
            </span>
            <span className="text-[15px] font-semibold text-white" data-id="element-62" data-mp="40zjzluu0rlp">
              Session Ready SLP — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-63" data-mp="3lfef5krikxy9">
            <span className="text-[15px] text-white/60 line-through" data-id="element-64" data-mp="3qh3q70eqlbmc">$90</span>
            <span className="font-display text-4xl leading-none text-white" data-id="element-65" data-mp="i08xgdrnl7lz">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-66" data-mp="mxiuoflaankd">
          <CtaButton data-id="element-67" data-mp="8347s3ylmu0f">Stack every group — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-68" data-mp="d1fh8dkzf2i4">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-69" data-mp="2xrmzq8aog4sr">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-70" data-mp="2xsy3w981beke" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}